import { PricingCard } from '@kkf/design'
import { PRICING_PLANS } from '../data/pricing'
import { useT } from '../i18n'

/** The pricing page. */
export function PricingPage() {
  const t = useT()
  return (
    <>
      {/*
        No banner and no breadcrumb (2026-09-21), the way `/about`, `/contact`, `/blog` and
        the legal pair lost theirs. `Breadcrumb` IS the photographic band — the trail sat
        inside it — so both went together. Two things travel with that, and each passes
        every gate this repo has:

        1. **It carried the page's only `<h1>`.** `audit:seo` fails a page with any number
           other than one, so the title is `.ul-plain-page-title` here — the class that
           exists for exactly this, beside `.ul-plain-page-top` in `_header.scss`.
        2. **The page now opens pale**, and the header's links are white at rest because
           the usual first section is a dark band. This route is in `header.plainRoutes`
           in `data/shell` as of the same day. Forget that and every link in the nav is
           white on near-white, and nothing anywhere goes red.
      */}
      <section className="ul-plain-page-top ul-pricing ul-section-spacing">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('page.pricing')}</h1>
          <div className="row ul-bs-row row-cols-lg-3 row-cols-sm-2 row-cols-1">
            {PRICING_PLANS.map((plan) => (
              <div className="col" key={plan.name}>
                <PricingCard {...plan} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
